/* After Dark collection sort safety asset 2026-08-14 */
(function () {
  var orders = {
    "new-in": "ads-lng-030,ads-lng-003,ads-lng-007,ads-lng-011,ads-lng-023,ads-lng-025,ads-lng-021,ads-lng-006,ads-lng-004,ads-lng-029,ads-lng-024,ads-lng-017,ads-lng-010,ads-slp-010,ads-slp-008,ads-slp-011,ads-slp-003,ads-lng-002,ads-lng-013,ads-lng-028,ads-lng-008",
    "lingerie": "ads-lng-030,ads-lng-003,ads-lng-007,ads-lng-011,ads-lng-023,ads-lng-025,ads-lng-021,ads-lng-006,ads-lng-004,ads-lng-029,ads-lng-024,ads-lng-017,ads-lng-010,ads-lng-002,ads-lng-013,ads-lng-028,ads-lng-008,ads-lng-009,ads-lng-026",
    "sleepwear": "ads-slp-010,ads-slp-008,ads-slp-011,ads-slp-003,ads-slp-001,ads-slp-007,ads-slp-004,ads-slp-006,ads-slp-005,ads-slp-009,ads-slp-002",
    "curve": "ads-lng-023,ads-lng-002,ads-lng-013,ads-lng-012,ads-lng-027",
    "costumes": "ads-lng-027,ads-lng-014,ads-lng-012,ads-lng-020,ads-lng-022,ads-lng-019,ads-lng-016,ads-lng-028,ads-lng-013,ads-lng-030",
    "bodystockings": "ads-lng-009"
  };

  function currentCollectionHandle() {
    var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function shouldRun() {
    var params = new URLSearchParams(window.location.search);
    var page = params.get("page") || "1";
    var sort = params.get("sort_by") || "manual";
    return page === "1" && sort === "manual" && orders[currentCollectionHandle()];
  }

  function productHandle(anchor) {
    try {
      var parts = new URL(anchor.href, window.location.origin).pathname.split("/").filter(Boolean);
      return parts[parts.length - 1] || "";
    } catch (error) {
      return "";
    }
  }

  function sortCollectionGrid() {
    if (!shouldRun()) return;
    var grid = document.querySelector(".ad-bb-coll__grid");
    if (!grid) return;
    var wanted = orders[currentCollectionHandle()].split(",");
    var rank = {};
    wanted.forEach(function (handle, index) {
      rank[handle] = index;
    });
    var items = Array.prototype.slice.call(grid.children);
    items.sort(function (a, b) {
      var aHandle = productHandle(a.querySelector('a[href*="/products/"]') || {});
      var bHandle = productHandle(b.querySelector('a[href*="/products/"]') || {});
      var aRank = Object.prototype.hasOwnProperty.call(rank, aHandle) ? rank[aHandle] : 9999;
      var bRank = Object.prototype.hasOwnProperty.call(rank, bHandle) ? rank[bHandle] : 9999;
      return aRank - bRank;
    });
    items.forEach(function (item) {
      grid.appendChild(item);
    });
    grid.dataset.adManualSortSafety = "done";
  }

  document.addEventListener("DOMContentLoaded", sortCollectionGrid);
  window.addEventListener("load", sortCollectionGrid);
  setTimeout(sortCollectionGrid, 300);
  setTimeout(sortCollectionGrid, 1200);
  setTimeout(sortCollectionGrid, 2600);
})();
